import { editCustomerDocumentName } from "api/Customers";
import { queryClient } from "lib/helpers/configs/queryClient";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

export const useEditCustomerDocumentName = () => {
  return useMutation(editCustomerDocumentName, {
    onSuccess: () => {
      queryClient.invalidateQueries("customerDocument");
      queryClient.refetchQueries("customerDocument", { exact: true });
      toast.success("Changed Successfully");
    },
    onError: () => {
      toast.error(`Something went wrong`);
    },
  });
};
